<template>
  <div class="gif-sticker-container" @click="reconnectConciergerie">
    <Tooltip :active="disabled || !isConciergerie" :text="!isConciergerie ? $t('dash.bots.status_proxy') : $t('dash.post.error.need_video.title')" position="top">
      <vs-button
        type="border"
        color="rgba(0, 0, 0, 0.2)"
        class="gif-btn"
        icon="gif"
        @click="addGif"
        :disabled="disabled || !isConciergerie"
        >{{ $t('dash.post.btn.add_gif') }}</vs-button
      >
    </Tooltip>
    <div class="auto-mentions row box" v-if="gifIsOpen">
      <div class="search-box-gif">
        <vs-input
          color="#B20564"
          type="text"
          name="search-mention"
          class="inputx"
          :placeholder="'Rechercher un gif'"
          v-model="searchedGif"
          v-on:keyup="searchGif"
          v-on:click="searchGif"
          ref="inputSearchGif"
          autocomplete="off"
          v-on:keydown.enter.prevent
        />
        <vs-button
          class="page-btn"
          vs-type="filled"
          color="#6a1f4c"
          @click.prevent="insertGif"
          >OK</vs-button
        >
      </div>
      <div id="loading-gif" class="vs-con-loading__container gifs-list">
        <img
          :class="`gif-item ${
            selectedGif && selectedGif.id === gif.id && 'selected'
          }`"
          v-for="gif of gifsList"
          :key="gif.id"
          :src="gif.images.preview_gif.url"
          @click="selectGif(gif)"
          :alt="gif.name"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Posts from '../mixins/Posts'
import Notif from '../mixins/Notif'
import Tooltip from './tooltip/tooltipInit.vue'

export default {
  mixins: [Posts, Notif],

  props: {
    pageId: String,
    disabled: Boolean,
    isConciergerie: Boolean
  },

  components: {
    Tooltip
  },

  mounted() {},

  data() {
    return {
      gifIsOpen: false,
      gifsList: [],
      searchedGif: '',
      selectedGif: null
    }
  },

  computed: {},

  methods: {

    reconnectConciergerie() {
      if (!this.isConciergerie) {
        this.$emit("reconnect");
      }
    },

    async addGif() {
      console.log('addGif')
      this.gifIsOpen = true
      this.$nextTick(() => {
        document
          .getElementsByClassName('gif-btn')[0]
          .classList.remove('isActive')
        this.$vs.loading({
          container: '#loading-gif',
          scale: 0.6
        })
        this.getTrendGifsInstagram(this.pageId).then((result) => {
          //Ajouter la listes des gif dans gifsList
          console.log('GIF:', result)
          if (
            result.ok &&
            result.body &&
            result.body.success &&
            result.body.gifs &&
            result.body.gifs.results &&
            result.body.gifs.results.giphy
          ) {
            this.gifsList = result.body.gifs.results.giphy
          } else {
            this.notify({
              title: 'Erreur',
              text: this.$t(result.body.error),
              color: 'danger',
              time: 10000,
              id: this.pageId
            })
          }
          this.$vs.loading.close('#loading-gif > .con-vs-loading')
        })
      })
    },

    selectGif(gif) {
      console.log('gif selected : ', gif)
      this.selectedGif = gif
    },

    insertGif() {
      console.log('gif selected : ', this.selectedGif)
      this.gifIsOpen = false
      if (this.selectedGif) {
        this.$emit('insertGif', this.selectedGif)
      }
    },

    searchGif() {
      console.log('search:', this.searchedGif)
      if (this.searchedGif.length > 0) {
        let search = this.searchedGif.repeat(1)
        setTimeout(() => {
          if (this.searchedGif === search) {
            this.$vs.loading({
              container: '#loading-gif',
              scale: 0.6
            })
            this.searchGifsInstagram(this.pageId, search).then((result) => {
              console.log(result)
              if (
                result.ok &&
                result.body &&
                result.body.success &&
                result.body.gifs &&
                result.body.gifs.results &&
                result.body.gifs.results.giphy
              ) {
                this.gifsList = result.body.gifs.results.giphy
              } else {
                this.notify({
                  title: 'Erreur',
                  text: this.$t(result.body.error),
                  color: 'danger',
                  time: 10000,
                  id: this.pageId
                })
              }
              this.$vs.loading.close('#loading-gif > .con-vs-loading')
            })
          }
        }, 800)
      }
      //Attendre au moins 3 char avant d'envoyer une requete
    }
  }
}
</script>

<style>
</style>